import type { FC } from "react";

import AsyncSelect from "react-select/async";

import type { InputComponentProps } from "../../basic/input";

import { InputComponent } from "../../basic/input";

interface AsyncProps extends InputComponentProps<any, any> {
	id: string;
	fullLength?: boolean;
	loadOptions?: (inputValue: string) => Promise<any[]>;
	changeHandler?: (value: any, id?: string) => void;
	value: any;
}

export const AsyncDropdownList: FC<AsyncProps> = (props) => {
	const { fullLength = true, loadOptions, changeHandler, label, placeholder, ...inputProps } = props;

	return (
		<InputComponent id={props.id} label={label} {...inputProps} className={fullLength ? "w-full" : ""}>
			<AsyncSelect
				cacheOptions
				value={props.value}
				onChange={(newValue) => changeHandler(newValue)}
				loadOptions={loadOptions}
				defaultOptions
				className="w-full"
				isClearable
				placeholder={placeholder}
			/>
		</InputComponent>
	);
};
